module.exports = "<symbol id=\"thebestco-uikit-svg-Up12\" viewBox=\"0 0 12 12\"><path d=\"M1.41 9.41L6 4.83L10.59 9.41L12 8L6 2L0 8L1.41 9.41Z\"/></symbol>";